const API_URL = 'https://mail-proline.project-management.uk';

export async function sendEmail({ to, subject, htmlBody, attachments }) {
  const response = await fetch(`${API_URL}/send-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ to, subject, htmlBody, ...(attachments ? { attachments } : {}) }),
  });

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(`Email server returned ${response.status} (no JSON body)`);
  }

  if (!data.success) throw new Error(data.error || 'Unknown email error');
  return data;
}
